import React  from 'react';
import {
    Form, Button 
} from 'antd';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { InputField, required,  phoneNumber, email,number  } from '../../app/inputs/InputField';
let FormEditarCliente = props => {

    return (
      <Form onSubmit={props.handleSubmit(props.editar)} layout="horizontal"  >
        <Field name="NOMBRE" component={InputField} ph="Nombre Cliente"/>
        <Field name="DIRECCIÓN" component={InputField} ph="Calle y numero"/>
        <Field name="COLONIA" component={InputField} ph="Poblacion"/>
        <Field name="POBLACIÓN" component={InputField} ph="Estado"/>
        <Field name="MUNICIPIO" component={InputField} ph="Municipio"/>
        <Field name="CP" component={InputField} ph="Codigo postal" />
        <Field name="RFC" component={InputField} ph="RFC" validate={[required]} />
        <Field name="TELÉFONO" component={InputField} ph="Telefono" validate={[phoneNumber,number]}/>
        <Field name="CORREO" component={InputField} ph="Correo" validate={[email]}/>
        <Form.Item>
          <div style={{display:"flex", justifyContent:"center"}}>
            <Button loading={props.loading} icon="edit" type="primary" htmlType="submit" className="loginFormButton">
              Guardar
            </Button>
          </div>
        </Form.Item>

      </Form>
    )
  }

  FormEditarCliente = reduxForm({
    form: 'FormEditarCliente',
    forceUnregisterOnUnmount:true,
    destroyOnUnmount:true,
    enableReinitialize:true
  
  })(FormEditarCliente)

  FormEditarCliente = connect(
    state => ({
      initialValues: state.reducerClientes.detailCliente // pull initial values from account reducer
    }),
    //{ load: loadAccount } // bind account loading action creator
  )(FormEditarCliente)

  export default FormEditarCliente


